/* @ngInject */
export default function NvColorPicker(
  _,
  $timeout,
  CurrentUserManager,
  CurrentCourseManager,
) {
  return {
    scope: {
      ngModel: '=',
      showColor: '=?',
      onBlur: '&?',
      required: '=?',
      form: '=?',
      name: '@?',
    },
    require: ['nvColorPicker', 'ngModel'],
    controller: function ctrl($scope, $element, $attrs) {
'ngInject';
      const vm = this;

      vm.CurrentUserManager = CurrentUserManager;
      vm.CurrentCourseManager = CurrentCourseManager;

      vm.brandColors = [...new Set([vm.CurrentCourseManager.course.institutionBrandColor, vm.CurrentCourseManager.course.headerColor].filter(x => x))];
      vm.colorsText = $.FE.DEFAULTS.colorsText;
    },
    link(scope, element, attrs, ctrls) {
      const [vm, ngModelCtrl] = ctrls;

      function showColorPicker() {
        $timeout(() => {
          vm.showColorPicker = true;
        });
      }

      function closeColorPicker(e = null, forceClose = false) {
        const close = () => {
          $timeout(() => {
            vm.showColorPicker = false;
          });
        };

        if (forceClose) {
          close();
        } else if (e) {
          const $target = $(e.target);

          if (!$target.closest(element).length) {
            close();
          }
        }
      }

      // for input
      vm.onFocus = () => {
        showColorPicker();
      };

      // for color picker
      vm.onMouseDown = (e) => {
        e.preventDefault();
      };

      vm.selectColor = (color) => {
        ngModelCtrl.$setViewValue(color);
      };

      element.on('focusout', (event) => {
        const $relatedTarget = $(event.relatedTarget);

        if (!$relatedTarget.closest(element).length) {
          if (!_.contains(vm.brandColors, vm.ngModel)) {
            CurrentUserManager.user.addRecentColor(vm.ngModel);
          }

          closeColorPicker(event, true);

          vm.onBlur(event);
        }
      });
    },
    controllerAs: 'vm',
    bindToController: true,
    templateUrl: 'shared/templates/nv-color-picker.html',
  };
}
